// extracted by mini-css-extract-plugin
module.exports = {"container":"StartPageSwitcher_container__EfhZ3","link":"StartPageSwitcher_link__FVNus","selected":"StartPageSwitcher_selected__MJfVq"};